import React, { useRef, useState } from "react";
import "../../../css/Login.css";
import "../../../css/ApplicationPreview.css";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import ERPUtils from "../../../helper/Utils";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { id } from "date-fns/locale";
import ApplicationPreviewPrint from "./ApplicationPreviewPrint";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";
import FileOpenIcon from '@mui/icons-material/FileOpen';

// import moment from 'moment';
import { Avatar, Box, Button, DialogContent, DialogTitle, IconButton, Link, List, Popover, Typography } from "@mui/material";

import "../../../css/Popup.css";
import ReactToPrint from "react-to-print";
import ApiGateway from "../../../helper/ApiGateway";

const ApplicationPreview = (props) => {
  const { open, close, previewData, getDob } = props;
  const [previewApplicantImage, setPreviewApplicantImage] = useState(false);
  const [applicantImage, setApplicantImage] = useState("");
  //const [previewData, setPreviewData] = useState(null);
  const [listItems, setlistItems] = useState([]);
  const calculateAge = (dateOfBirth) => {
    const parts = dateOfBirth.split("/");
    const day = parseInt(parts[0]);
    const month = parseInt(parts[1]);
    const year = parseInt(parts[2]);

    // Array of month abbreviations
    const monthAbbreviations = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedDate = `${day}-${monthAbbreviations[month - 1]}-${year}`;
    const birthDate = new Date(formattedDate);
    const today = new Date();
    const age = Math.floor((today - birthDate) / 31536000000);

    return age;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [popover, setpopover] = useState(false);

  const handleClick = (event, array) => {
    setlistItems(array);
    setAnchorEl(event.currentTarget);

    setpopover(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setlistItems([]);
    setpopover(false);
  };
  const openDocumentInNewTab = async (item) => {
    try {
      const getUrl = await ERPUtils.getPresignedUrl(item.actualPath, item.processCode, item.originalFileName);
      const fileExtension = item.originalFileName.split(".").pop();
      let newContentType;

      if (["jpg", "jpeg", "png", "gif"].includes(fileExtension.toLowerCase())) {
        newContentType = `image/${fileExtension}`;
      } else if (["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(fileExtension.toLowerCase())) {
        newContentType = `application/${fileExtension}`;
      } else {
        newContentType = "application/octet-stream"; // Default to a generic binary content type if extension is unknown
      }

      const response = await axios.get(getUrl, {
        responseType: "arraybuffer", // To handle binary data like PDFs
      });

      const { headers, data } = response;

      const contentDisposition = `attachment; filename="${item.originalFileName}"`;

      // Create a Blob from the binary data
      const blob = new Blob([data], { type: newContentType });

      // Create an object URL for the Blob
      const blobUrl = URL.createObjectURL(blob);

      // Open the object URL in a new window
      const newTab = window.open(blobUrl, "_blank");

      // Clean up the object URL when the new tab is closed
      newTab.addEventListener("unload", () => {
        URL.revokeObjectURL(blobUrl);
      });
    } catch (error) {
      // Handle errors
    }
  };

  const printComponentRef = useRef(null);
  const printRef = useRef(null);
  const handlePrint = () => {
    printRef?.current?.handlePrint();
  };

  const imagePopupHandler = (params) => {
    setApplicantImage(params?.data?.profilePhotoUrl || "");
    setPreviewApplicantImage(!previewApplicantImage);
  };

  const fetchData = async (presignedUrl, isDocument, extension) => {
    const contentType = isDocument ? "application/pdf" : `application/${extension}`;
    try {
      const response = await fetch(presignedUrl, {
        headers: {
          "Content-Type": contentType,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const arrayBuffer = await response.arrayBuffer();
      const byteArray = new Uint8Array(arrayBuffer);

      // Create a Blob from the array buffer
      const blob = new Blob([byteArray], { type: contentType });

      // Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);

      return blobUrl;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      if (error.message.includes("HTTP error! Status:")) {
        console.error("Actual response status:", error.message.split("Status: ")[1]);
      }
    }
    return null;
  };

  const handleResume = () => {
    const resumeUrl = previewData?.empApplnPersonalDataDTO?.resumeUploadDTO
    let bodyData = Array.isArray(resumeUrl) ? resumeUrl : [resumeUrl];
    if (Array.isArray(resumeUrl)) {
      const documentList = {};
      for (let index = 0; index < bodyData.length; index++) {
        documentList.push(bodyData?.document);
      }
      bodyData = documentList;
    }
  
    const item = bodyData[0]; 

    ERPUtils.loading(props.tabId, true);

    ERPUtils.getPresignedUrl(item.actualPath, item.processCode, item.originalFileName)
      .then(async (presignedUrl) => {
        try {
          const spittedArray = item?.originalFileName?.split(".") || {};
          const extension = spittedArray[spittedArray.length - 1];
          const imageExtensionList = ["pdf", "docx"];
          const isDocumentExtension = !imageExtensionList.includes(String(extension).toLowerCase());

          const result = await fetchData(presignedUrl, isDocumentExtension, extension);

          if (result) {
            const link = document.createElement("a");
            link.href = result;
            link.download = item.originalFileName || `resume.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      })
      .catch((error) => {
        console.error("Error getting presigned URL:", error.message);
      })
      .finally(() => {
        ERPUtils.loading(props.tabId, false);
      });

  };

  return ERPUtils.isUndefinedOrNull(previewData) === false ? (
    <Dialog open={open} className="CustomDialog" maxWidth={false} fullWidth={true}>
      {/* <div style={{ margin: '0px', padding: '0px' }}> */}
      <DialogTitle style={{ position: "sticky", top: "0" }}>
        <div className="row">
          <div className="col-9" style={{ maxWidth: window.innerWidth > 768 ? "91.666667%" : "76.333333%" }}>
            <label className="w-2 m-0 mx-2" style={{ verticalAlign: "bottom" }}>
              {previewData?.empApplnPersonalDataDTO?.profilePhotoUrl ? (
                <span className="shortlist-applications-applicant-image me-2" onMouseEnter={() => imagePopupHandler} onMouseLeave={imagePopupHandler}>
                  <img
                    src={previewData?.empApplnPersonalDataDTO?.profilePhotoUrl}
                    alt="profile-icons"
                    height="65px"
                    width="65px"
                    style={{ borderRadius: "50%", marginBottom: window.innerWidth > 768 ? "5px" : "23px", marginRight: window.innerWidth > 768 ? "5px" : null }}
                  />
                </span>
              ) : (
                <Avatar
                  sx={{
                    marginRight: "8px",
                    width: "52px",
                    height: "53px",
                  }}
                >
                  {previewData.applicantName?.split("")[0]}
                </Avatar>
              )}
              {previewData.applicantName}
            </label>
            <label>
              {ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO) === false ? (
                <b>
                  {!ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.applicantName) && !ERPUtils.isUndefinedOrNull(previewData?.applicationNo)
                    ? `${previewData.empApplnPersonalDataDTO?.applicantName}${` (${previewData?.applicationNo})`}`
                    : ""}
                </b>
              ) : null}
              <br />
              {ERPUtils.isUndefinedOrNull(previewData.jobDetailDTO) === false
                ? `Applying for the Post of ${ERPUtils.isUndefinedOrNull(previewData?.empAppliedEmployeCategory?.label) === false ? previewData?.empAppliedEmployeCategory?.label : ""
                } ${ERPUtils.isUndefinedOrNull(previewData?.jobDetailDTO?.subjectCategoryIds) === false
                  ? previewData?.jobDetailDTO?.subjectCategoryIds.map((el) => `/${el}`)
                  : ""
                }
											${ERPUtils.isUndefinedOrNull(previewData.jobDetailDTO?.specializationIds) === false ? previewData?.jobDetailDTO?.specializationIds.map((el) => `/${el}`) : ""}`
                : null}{" "}
              <br />
              {ERPUtils.isUndefinedOrNull(previewData.jobDetailDTO) === false ? (
                <>
                  {ERPUtils.isUndefinedOrNull(previewData?.jobDetailDTO?.empApplnCampusPrefDTOList) === false
                    ? previewData?.jobDetailDTO?.empApplnCampusPrefDTOList.map((el) => `${el}, `)
                    : ""}
                </>
              ) : null}
            </label>
          </div>
          <div className="col-md-2 text-end">
            <ReactToPrint ref={(el) => (printRef.current = el)} content={() => printComponentRef.current} />
            <div className="print-only" ref={printComponentRef}>
              <ApplicationPreviewPrint ref={printComponentRef.current} previewData={previewData} calculateAge={calculateAge} getDob={getDob} />
            </div>

            <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
              {previewData?.empApplnPersonalDataDTO?.resumeUploadDTO && (
                <Button
                  variant="contained"
                  onClick={handleResume}
                  size="small"
                  endIcon={<FileOpenIcon />}
                >
                  RESUME
                </Button>
              )}
              <Button
                variant="contained"
                onClick={handlePrint}
                size="small"
                endIcon={<PrintIcon />}
              >
                PRINT
              </Button>
            </Box>

          </div>
          <div className="col-1 previewClose">
            <IconButton edge="end" color="inherit" onClick={close} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <section className="PreviewContent">
          <div className="row">
            <div>
              {popover ? (
                <div>
                  <Popover
                    id={id}
                    open={anchorEl}
                    onClose={handleClose}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <Typography sx={{ p: 2 }}>
                      {" "}
                      <List>
                        {listItems?.map((item, index) => (
                          <ListItem
                            key={index}
                            tabIndex={0}
                            onClick={() => openDocumentInNewTab(item)}
                            onKeyDown={(e) => (ERPUtils.isKeyBoardEnterPressed(e) ? openDocumentInNewTab(item) : null)}
                            //onKeyDown={(event)=> ERPUtils.isKeyBoardEnterPressed()}
                            sx={{
                              "&:hover": {
                                cursor: "pointer",
                                backgroundColor: "#eee",
                              },
                            }}
                          >
                            <ListItemText primary={item.originalFileName} />
                          </ListItem>
                          // <ListItem key={index}>
                          //   <ListItemText primary={item?.originalFileName} />
                          // </ListItem>
                        ))}
                      </List>
                    </Typography>
                  </Popover>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-md-5">
              {ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO) === false ? (
                <div className="previewBox previewBox-personal">
                  <div className="previewBox-header with-border">
                    <h3 className="previewBox-title">Personal Details</h3>
                  </div>
                  <div className="PreviewBoxBody">
                    <div className="row">
                      <label className="col-md-4 col-5 PreviewFormLabel">Gender</label>
                      <label className="col-md-8 col-5 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.genderId) === false
                          ? previewData?.empApplnPersonalDataDTO?.genderId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 col-5 PreviewFormLabel">Father's Name</label>
                      <label className="col-md-8 col-5 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.fatherName) === false
                          ? previewData?.empApplnPersonalDataDTO?.fatherName
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Mother's Name</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.motherName) === false
                          ? previewData?.empApplnPersonalDataDTO?.motherName
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Date of Birth</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.dateOfBirth) === false
                          ? getDob(previewData.empApplnPersonalDataDTO?.dateOfBirth)
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Age</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {!ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.dateOfBirth)
                          ? calculateAge(previewData.empApplnPersonalDataDTO?.dateOfBirth)
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Marital status</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.maritalStatusId) === false
                          ? previewData?.empApplnPersonalDataDTO?.maritalStatusId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Nationality</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.nationalityId) === false
                          ? previewData?.empApplnPersonalDataDTO?.nationalityId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Passport No</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.passportNo) === false
                          ? previewData?.empApplnPersonalDataDTO?.passportNo
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Aadhaar No</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.aadharNo) === false
                          ? previewData?.empApplnPersonalDataDTO?.aadharNo
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Religion</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.religionId) === false
                          ? previewData.empApplnPersonalDataDTO?.religionId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">Minority</label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.isMinority) === false
                          ? previewData?.empApplnPersonalDataDTO?.isMinority
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Reservation Category</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.reservationCategoryId) === false
                          ? previewData?.empApplnPersonalDataDTO?.reservationCategoryId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Blood Group</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.bloodGroupId) === false
                          ? previewData?.empApplnPersonalDataDTO?.bloodGroupId
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Date of Application</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.submissionDate) === false ? ERPUtils.convertLocalDateToDD_MMM_YYYY_String(previewData?.submissionDate) : "NA"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-4 PreviewFormLabel">
                        <b>Differently Abled</b>
                      </label>
                      <label className="col-md-8 PreviewFormLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.differentlyAbledId) === false
                          ? previewData?.empApplnPersonalDataDTO?.differentlyAbledId
                          : "-"}
                      </label>
                    </div>
                  </div>
                </div>
              ) : null}

              {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO) === false ||
                ERPUtils.isUndefinedOrNull(previewData?.addressDetailDTO) === false ? (
                <div className="previewBox previewBox-contact">
                  <div className="previewBox-header with-border">
                    <h3 className="previewBox-title">Contact Details</h3>
                  </div>
                  <div className="PreviewBoxBody">
                    <div className="row">
                      {/* <label className="col-md-1 PreviewFormLabel iconIconLabelLeft" /> */}
                      <label className="col-md-11 PreviewFormLabel iconDataLabel">
                        <span className="fa-solid fa-phone ps-3 pe-2" />
                        {ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO) === false
                          ? ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.mobileNo) === false ||
                            ERPUtils.isUndefinedOrNull(previewData.empApplnPersonalDataDTO?.alternateNo) === false
                            ? `${previewData.empApplnPersonalDataDTO?.mobileNo}  ${previewData.empApplnPersonalDataDTO?.alternateNo || ""}`
                            : "-"
                          : "-"}
                      </label>
                    </div>
                    <div className="row">
                      <label className="col-md-11 PreviewFormLabel iconIconLabelLeft">
                        <span className="fa fa-envelope SpanIcon ps-3 pe-2" />
                        {ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO) === false
                          ? ERPUtils.isUndefinedOrNull(previewData?.empApplnPersonalDataDTO?.emailId) === false
                            ? previewData?.empApplnPersonalDataDTO?.emailId
                            : "-"
                          : "-"}
                      </label>
                      {/* <label className="col-md-11 PreviewFormLabel iconDataLabel">
												
													</label> */}
                    </div>
                    {ERPUtils.isUndefinedOrNull(previewData?.addressDetailDTO) === false ? (
                      <div className="row text-break">
                        <label className="col-md-11 PreviewFormLabel iconIconLabelLeft" />
                        <div>
                          {" "}
                          {/* <span className="fa fa-address-book-o" aria-hidden="true" /> */}
                          <span>
                            <b>Current Address</b>
                          </span>
                          <label className="col-md-11 PreviewFormLabel iconDataLabel ">
                            <div style={{ display: "inline-flex" }}>
                              {`${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.currentAddressLine1) === false
                                ? previewData.addressDetailDTO?.currentAddressLine1
                                : ""
                                }, ${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.currentAddressLine2) === false
                                  ? previewData.addressDetailDTO?.currentAddressLine2
                                  : ""
                                }`}{" "}
                              <br />{" "}
                              {ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.currentPincode) === false
                                ? previewData.addressDetailDTO?.currentPincode
                                : ""}{" "}
                              <br />
                              {`${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.currentCityId) === false
                                ? previewData.addressDetailDTO?.currentCityId
                                : ""
                                }, ${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.currentStateId) === false
                                  ? previewData.addressDetailDTO?.currentStateId
                                  : ""
                                }`}
                            </div>
                          </label>
                        </div>
                      </div>
                    ) : null}
                    {ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO) === false ? (
                      <div className="row text-break">
                        <label className="col-md-11 PreviewFormLabel iconIconLabelLeft" />
                        <div>
                          {" "}
                          {/* <span className="fa-solid fa-location-arrow" style={{ color: "#666666" }} /> */}
                          <span>
                            <b>Permanent Address</b>
                          </span>
                          <label className="col-md-11 PreviewFormLabel iconDataLabel ">
                            <div style={{ display: "inline-flex" }}>
                              {`${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.permanentAddressLine1) === false
                                ? previewData.addressDetailDTO?.permanentAddressLine1
                                : ""
                                }, ${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.permanentAddressLine2) === false
                                  ? previewData.addressDetailDTO?.permanentAddressLine2
                                  : ""
                                }`}{" "}
                              <br />{" "}
                              {ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.permanentPincode) === false
                                ? previewData.addressDetailDTO?.permanentPincode
                                : ""}{" "}
                              <br />
                              {`${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.permanentCityId) === false
                                ? previewData.addressDetailDTO?.permanentCityId
                                : ""
                                }, ${ERPUtils.isUndefinedOrNull(previewData.addressDetailDTO?.permanentStateId) === false
                                  ? previewData.addressDetailDTO?.permanentStateId
                                  : ""
                                }`}
                            </div>
                          </label>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}

              {ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO) === false ? (
                ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.professionalExperienceList) === false ? (
                  <div className="previewBox previewBox-professionalDetails">
                    <div className="previewBox-header with-border">
                      <h3 className="previewBox-title">Professional Details</h3>
                    </div>
                    <div className="PreviewBoxBody">
                      {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience) === false ? (
                        <div className="row">
                          <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                            {/* <span class="glyphicon glyphicon-asterisk SpanIcon" /> */}
                            <span className="fa fa-star SpanIcon" />
                          </label>
                          <label className="col-md-11 PreviewFormLabel iconDataLabel">
                            {`${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO.currentExperience?.designation) === false
                              ? previewData?.professionalExperienceDTO?.currentExperience.designation
                              : ""
                              } - ${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO.currentExperience?.functionalAreaOthers) === false
                                ? previewData.professionalExperienceDTO?.currentExperience.functionalAreaOthers
                                : ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.functionalAreaId) === false
                                  ? previewData?.professionalExperienceDTO?.currentExperience.functionalAreaId
                                  : ""
                              }`}{" "}
                            <br />
                            {`${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO.currentExperience?.institution) === false
                              ? previewData?.professionalExperienceDTO?.currentExperience.institution
                              : ""
                              }`}{" "}
                            <br />
                            {/* total experience calculation{ERPUtils.isUndefinedOrNull(
																previewData.professionalExperienceDTO.currentExperience
																	.fromDate
															) === false &&
																ERPUtils.isUndefinedOrNull(
																	previewData.professionalExperienceDTO.currentExperience
																		.toDate
																) === false ? (
																`From
															${new Date(
																	moment(previewData.professionalExperienceDTO.currentExperience.fromDate, "DD/MM/YYYY")
																).getDate()}${new Date(
																	moment(
																		previewData.professionalExperienceDTO
																			.currentExperience.fromDate, "DD/MM/YYYY"
																	)
																).getMonth() + 1}-${new Date(
																	moment(
																		previewData.professionalExperienceDTO
																			.currentExperience.fromDate, "DD/MM/YYYY"
																	)
																).getFullYear()} - ${new Date(
																	moment(
																		previewData.professionalExperienceDTO
																			.currentExperience.toDate, "DD/MM/YYYY"
																	)
																).getDate()}-${new Date(
																	moment(
																		previewData.professionalExperienceDTO
																			.currentExperience.toDate, "DD/MM/YYYY"
																	)
																).getMonth() + 1}-${new Date(
																	moment(
																		previewData.professionalExperienceDTO
																			.currentExperience.toDate, "DD/MM/YYYY"
																	)
																).getFullYear()}`
															) : null} */}
                            {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.fromDate) === false &&
                              ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.toDate) === false
                              ? `From
									${ERPUtils.convertLocalDateToDD_MMM_YYYY_String(previewData?.professionalExperienceDTO?.currentExperience.fromDate)} 
																	to ${ERPUtils.convertLocalDateToDD_MMM_YYYY_String(previewData?.professionalExperienceDTO?.currentExperience.toDate)}`
                              : null}
                            <br />
                            {`${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.years) === false
                              ? previewData?.professionalExperienceDTO?.currentExperience.years
                              : ""
                              } ${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.years) === false
                                ? previewData?.professionalExperienceDTO?.currentExperience.years > 1
                                  ? "Years"
                                  : "Year"
                                : ""
                              } ${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.months) === false
                                ? previewData?.professionalExperienceDTO?.currentExperience.months
                                : ""
                              } ${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.months) === false
                                ? previewData?.professionalExperienceDTO?.currentExperience.months > 1
                                  ? "Months"
                                  : "Month"
                                : ""
                              } of experience`}
                            <br />
                            {!ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.currentExperience?.experienceDocumentList) ? (
                              <Link
                                aria-describedby={anchorEl}
                                component="button"
                                variant="body2"
                                onClick={(e) => handleClick(e, previewData.professionalExperienceDTO?.currentExperience?.experienceDocumentList)}
                                underline="none"
                              >
                                View Documents
                              </Link>
                            ) : (
                              ""
                            )}
                          </label>
                        </div>
                      ) : null}

                      {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.professionalExperienceList) === false
                        ? previewData?.professionalExperienceDTO?.professionalExperienceList.map((el, index) => {
                          return (
                            <div className="row" key={index}>
                              <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                                <span className="fa fa-star SpanIcon" />
                              </label>
                              <label className="col-md-11 PreviewFormLabel iconDataLabel">
                                {`${ERPUtils.isUndefinedOrNull(el?.designation) === false ? el?.designation : ""} - ${ERPUtils.isUndefinedOrNull(el?.functionalAreaOthers) === false
                                  ? el?.functionalAreaOthers
                                  : ERPUtils.isUndefinedOrNull(el?.functionalAreaId) === false
                                    ? el?.functionalAreaId
                                    : ""
                                  }`}
                                <br />
                                {`${ERPUtils.isUndefinedOrNull(el.institution) === false ? el.institution : ""}`} <br />
                                {ERPUtils.isUndefinedOrNull(el?.fromDate) === false && ERPUtils.isUndefinedOrNull(el?.toDate) === false
                                  ? `From ${ERPUtils.convertLocalDateToDD_MMM_YYYY_String(el.fromDate)}
																			to 
										${ERPUtils.convertLocalDateToDD_MMM_YYYY_String(el.toDate)}
										`
                                  : ""}
                                <br />
                                {`${ERPUtils.isUndefinedOrNull(el.years) === false ? el?.years : ""} ${ERPUtils.isUndefinedOrNull(el.years) === false ? (el?.years > 1 ? "Years" : "Year") : ""
                                  } ${ERPUtils.isUndefinedOrNull(el?.months) === false ? el?.months : ""} ${ERPUtils.isUndefinedOrNull(el?.months) === false ? (el?.months > 0 ? "Months" : "Month") : ""
                                  } of experience`}
                                <br />
                                {!ERPUtils.isUndefinedOrNull(el?.experienceDocumentList) ? (
                                  <Link
                                    aria-describedby={anchorEl}
                                    component="button"
                                    variant="body2"
                                    onClick={(e) => handleClick(e, el?.experienceDocumentList)}
                                    underline="none"
                                  >
                                    View Documents
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </label>
                            </div>
                          );
                        })
                        : null}
                    </div>
                  </div>
                ) : null
              ) : null}

              {ERPUtils.isUndefinedOrNull(previewData?.majorAchievements) === false ? (
                <div className="previewBox previewBox-Achivements ">
                  <div className="previewBox-header with-border">
                    <h3 className="previewBox-title">Achievements</h3>
                  </div>
                  <div className="PreviewBoxBody">
                    <div className="row text-break">
                      <label className="col-md-1 PreviewFormLabel iconIconLabelLeft">
                        <span className="fa fa-arrow-right SpanIcon" />
                      </label>
                      <label className="col-md-11 PreviewFormLabel iconDataLabel">
                        {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.majorAchievements) === false
                          ? previewData?.professionalExperienceDTO?.majorAchievements
                          : previewData.majorAchievements}
                      </label>
                    </div>
                  </div>
                </div>
              ) : null}
              {/* ) : null} */}
              {/* {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) === false ? (
										<div className="previewBox previewBox-profileSummary">
											<div className="previewBox-header with-border">
												<h3 className="previewBox-title">Research Details</h3>
											</div>
											<div className="PreviewBoxBody">
												<div className="row">
													<label className="col-md-3 PreviewFormLabel">
														Vidwan ID
													</label>
													<label className="col-md-9 PreviewFormLabel">
														{ERPUtils.isUndefinedOrNull(
															previewData.researchDetailDTO.inflibnetVidwanNo
														) === false ? (
															previewData.researchDetailDTO.inflibnetVidwanNo
														) : (
															'-'
														)}
													</label>
												</div>
												<div className="row">
													<label className="col-md-3 PreviewFormLabel">
														Scopus ID
													</label>
													<label className="col-md-9 PreviewFormLabel">
														{ERPUtils.isUndefinedOrNull(
															previewData.researchDetailDTO.scopusId
														) === false ? (
															previewData.researchDetailDTO.scopusId
														) : (
															'-'
														)}
													</label>
												</div>
												<div className="row">
													<label className="col-md-3 PreviewFormLabel">
														H Index
													</label>
													<label className="col-md-9 PreviewFormLabel">
														{ERPUtils.isUndefinedOrNull(
															previewData.researchDetailDTO.hIndex
														) === false ? (
															previewData.researchDetailDTO.hIndex
														) : (
															'-'
														)}
													</label>
												</div>
												<div className="row">
													<label className="col-md-3 PreviewFormLabel">
														Orcid ID
													</label>
													<label className="col-md-9 PreviewFormLabel">
														{ERPUtils.isUndefinedOrNull(
															previewData.researchDetailDTO.orcidId
														) === false ? (
															previewData.researchDetailDTO.orcidId
														) : (
															'-'
														)}
													</label>
												</div>
											</div>
										</div>
									) : null} */}
            </div>

            <div className="col-md-7">
              {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO) === false ? (
                ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceMonths) === false ||
                  ERPUtils.isNullorWhiteSpace(previewData?.professionalExperienceDTO?.currentExperience) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.expectedSalary) === false ? (
                  <div className="previewBox previewBox-profileSummary">
                    <div className="previewBox-header with-border">
                      <h3 className="previewBox-title">Profile summary</h3>
                    </div>
                    <div className="PreviewBoxBody">
                      {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceMonths) === false ||
                        ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceYears) === false ? (
                        <div className="row">
                          <label className="col-md-3 PreviewFormLabel">
                            <b>Full Time Experience</b>
                          </label>
                          {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceMonths) === false ||
                            ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceYears) === false ? (
                            <label className="col-md-9 PreviewFormLabel">
                              {!ERPUtils.isNullorWhiteSpace(previewData.professionalExperienceDTO?.totalPreviousExperienceYears)
                                ? `${previewData.professionalExperienceDTO?.totalPreviousExperienceYears} years, `
                                : ""}
                              {!ERPUtils.isNullorWhiteSpace(previewData.professionalExperienceDTO?.totalPreviousExperienceMonths)
                                ? `${previewData.professionalExperienceDTO?.totalPreviousExperienceMonths} months`
                                : ""}
                              {/* {`${(ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears) === false ?
																			parseInt(previewData?.professionalExperienceDTO?.totalPartTimePreviousExperienceYears, 10) : 0) + (ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO.totalPreviousExperienceYears) === false ?
																				parseInt(previewData?.professionalExperienceDTO?.totalPreviousExperienceYears, 10) : 0)} years,
                          														${(ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPreviousExperienceMonths) === false ?
																				parseInt(previewData?.professionalExperienceDTO?.totalPreviousExperienceMonths, 10) : 0)
																			+ (ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths) === false ?
																				parseInt(previewData?.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths, 10) : 0)
																			} months`} */}
                            </label>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : null}
                      {ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears) === false ||
                        // || ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPreviousExperienceMonths) === false
                        ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths) === false ? (
                        // || ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPreviousExperienceYears) === false
                        <div className="row">
                          <label className="col-md-3 PreviewFormLabel">
                            <b>Part Time Experience</b>
                          </label>
                          {ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears) === false ||
                            ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths) === false ? (
                            <label className="col-md-9 PreviewFormLabel">
                              {!ERPUtils.isNullorWhiteSpace(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears)
                                ? `${previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceYears} years, `
                                : ""}
                              {!ERPUtils.isNullorWhiteSpace(previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths)
                                ? `${previewData.professionalExperienceDTO?.totalPartTimePreviousExperienceMonths} months`
                                : ""}
                            </label>
                          ) : (
                            "NA"
                          )}
                        </div>
                      ) : null}
                      {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience) === false ? (
                        <div className="row">
                          <label className="col-md-3 PreviewFormLabel">
                            <b>Current profile</b>
                          </label>
                          <label className="col-md-9 PreviewFormLabel">
                            {ERPUtils.isNullorWhiteSpace(previewData?.professionalExperienceDTO?.currentExperience) === false
                              ? `Working ${ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.currentExperience) === false
                                ? ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.designation) === false
                                  ? `as ${previewData?.professionalExperienceDTO?.currentExperience.designation}`
                                  : ""
                                : ""
                              } ${ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience) === false
                                ? ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.currentExperience.institution) === false
                                  ? `at ${previewData?.professionalExperienceDTO?.currentExperience.institution}`
                                  : ""
                                : ""
                              }`
                              : "NA"}
                          </label>
                        </div>
                      ) : null}
                      {ERPUtils.isUndefinedOrNull(previewData?.professionalExperienceDTO?.expectedSalary) === false ? (
                        <div className="row">
                          <label className="col-md-3 PreviewFormLabel">
                            <b>Salary Expected/Month</b>
                          </label>
                          <label className="col-md-9 PreviewFormLabel">
                            {ERPUtils.isUndefinedOrNull(previewData.professionalExperienceDTO?.expectedSalary) === false
                              ? previewData.professionalExperienceDTO?.expectedSalary
                              : 0}
                          </label>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null
              ) : null}
              {ERPUtils.isUndefinedOrNull(previewData.empApplnSubjectCategory) === false || ERPUtils.isUndefinedOrNull(previewData?.campusPreference) === false ? (
                <div className="previewBox previewBox-profileSummary">
                  <div className="previewBox-header with-border">
                    <h3 className="previewBox-title">Campus and Subject Category</h3>
                  </div>
                  <div className="PreviewBoxBody">
                    {ERPUtils.isUndefinedOrNull(previewData?.empApplnSubjectCategory) === false ? (
                      <div className="row">
                        {/* <label className="col-md-4 PreviewFormLabel">
														<b>Subject/Category</b>
													</label> */}
                        {!ERPUtils.isNullorWhiteSpace(previewData.academic) && previewData.academic === true ? (
                          <label className="col-md-4 PreviewFormLabel">
                            <b>Subject</b>
                          </label>
                        ) : (
                          <label className="col-md-4 PreviewFormLabel">
                            <b>Category</b>
                          </label>
                        )}
                        <label className="col-md-7 PreviewFormLabel">
                          {ERPUtils.isUndefinedOrNull(previewData?.empApplnSubjectCategory) === false ? previewData.empApplnSubjectCategory : ""}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {ERPUtils.isUndefinedOrNull(previewData?.jobCategoryDTO?.label) === false ? (
                      <div className="row">
                        <label className="col-md-4 PreviewFormLabel">
                          <b>Job Category</b>
                        </label>
                        <label className="col-md-7 PreviewFormLabel">
                          {ERPUtils.isUndefinedOrNull(previewData?.jobCategoryDTO?.label) === false ? previewData.jobCategoryDTO?.label : ""}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {ERPUtils.isUndefinedOrNull(previewData?.empApplnSubjectCategorySpecialization) === false ? (
                      <div className="row">
                        <label className="col-md-4 PreviewFormLabel">
                          <b>Specialization</b>
                        </label>
                        <label className="col-md-7 PreviewFormLabel">
                          {ERPUtils.isUndefinedOrNull(previewData?.empApplnSubjectCategorySpecialization) === false
                            ? previewData.empApplnSubjectCategorySpecialization
                            : ""}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    {ERPUtils.isUndefinedOrNull(previewData?.campusPreference) === false ? (
                      <div className="row">
                        <label className="col-md-4 PreviewFormLabel">
                          <b>Campus Preferred</b>
                        </label>
                        <label className="col-md-7 PreviewFormLabel">
                          {/* {ERPUtils.isUndefinedOrNull(previewData?.campusPreference) === false ? previewData?.campusPreference : ""} */}
                          {ERPUtils.isUndefinedOrNull(previewData?.campusPreference) === false
                            ? previewData?.campusPreference?.split(",").map((item, index) => (
                              <div>
                                <span>
                                  {index + 1}
                                  .
                                  {" "}
                                </span>
                                <span>
                                  {item}
                                </span>
                              </div>
                            )) : ""}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : null}

              {ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO) === false ? (
                ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO?.qualificationLevelsList) === false ||
                  ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO?.otherQualificationLevelsList) === false ||
                  ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO.eligibilityTestList) === false ? (
                  <div className="previewBox previewBox-personal">
                    <div className="previewBox-header with-border">
                      <h3 className="previewBox-title">Educational Details</h3>
                    </div>
                    <div className="PreviewBoxBody">
                      {ERPUtils.isUndefinedOrNull(previewData?.educationalDetailDTO?.highestQualificationLevelId) === false ? (
                        <div className="row ">
                          <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                            <span className="fa fa-star SpanIcon" />
                          </label>

                          <label className="col-md-11 PreviewFormLabel iconDataLabel">
                            <b>Highest Qualification Level</b>
                            <br />
                            {ERPUtils.isUndefinedOrNull(previewData?.educationalDetailDTO?.highestQualificationLevelId) === false
                              ? previewData?.educationalDetailDTO?.highestQualificationLevelId
                              : ""}
                          </label>
                        </div>
                      ) : (
                        ""
                      )}
                      {ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO?.qualificationLevelsList) === false
                        ? previewData.educationalDetailDTO?.qualificationLevelsList
                          .sort((a, b) => parseInt(b?.yearOfCompletion, 10) - parseInt(a?.yearOfCompletion, 10))
                          .map((el, index) => {
                            return (
                              <div className="row" key={index}>
                                <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                                  <span className="fa fa-star SpanIcon" />
                                </label>
                                <label className="col-md-11 PreviewFormLabel iconDataLabel">
                                  {`${ERPUtils.isNullorWhiteSpace(el?.qualificationLevelId) === false ? el?.qualificationLevelId : ""} - ${ERPUtils.isNullorWhiteSpace(el.course) === false ? el.course : ""
                                    }`}
                                  <br />
                                  {`${ERPUtils.isNullorWhiteSpace(el?.boardOrUniversity) === false ? el?.boardOrUniversity : ""}/ ${ERPUtils.isNullorWhiteSpace(el.institute) === false ? el.institute : ""
                                    }`}
                                  <br />

                                  {`Current status - ${parseInt(el.currentStatus) === 1 ? "Pursuing" : "Completed"}`}
                                  <br />
                                  {`${parseInt(el.currentStatus) === 1 ? "Year of joining" : "Year of completion"} - ${ERPUtils.isNullorWhiteSpace(el?.yearOfCompletion) === false ? el?.yearOfCompletion : ""
                                    }`}
                                  <br />
                                  {`${ERPUtils.isNullorWhiteSpace(el?.specialization) === false ? el?.specialization : ""}`}
                                  <br />
                                  {!ERPUtils.isUndefinedOrNull(el?.documentList) ? (
                                    <Link aria-describedby={anchorEl} component="button" onClick={(e) => handleClick(e, el.documentList)} underline="none">
                                      View Documents
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </label>
                              </div>
                            );
                          })
                        : null}

                      {ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO?.otherQualificationLevelsList) === false
                        ? previewData.educationalDetailDTO?.otherQualificationLevelsList
                          .sort((a, b) => parseInt(b?.yearOfCompletion, 10) - parseInt(a?.yearOfCompletion, 10))
                          .map((el, index) => {
                            return (
                              <div className="row" key={index}>
                                <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                                  <span className="fa fa-star SpanIcon" />
                                </label>
                                <label className="col-md-11 PreviewFormLabel iconDataLabel">
                                  {`${ERPUtils.isNullorWhiteSpace(el?.qualificationLevelId) === false ? el?.qualificationLevelId : ""} - ${ERPUtils.isNullorWhiteSpace(el.course) === false ? el.course : ""
                                    }`}
                                  <br />
                                  {`${ERPUtils.isNullorWhiteSpace(el?.boardOrUniversity) === false ? el?.boardOrUniversity : ""}/ ${ERPUtils.isNullorWhiteSpace(el.institute) === false ? el.institute : ""
                                    }`}
                                  <br />

                                  {`Current status - ${parseInt(el.currentStatus) === 1 ? "Pursuing" : "Completed"}`}
                                  <br />
                                  {`${parseInt(el.currentStatus) === 1 ? "Year of joining" : "Year of completion"} - ${ERPUtils.isNullorWhiteSpace(el?.yearOfCompletion) === false ? el?.yearOfCompletion : ""
                                    }`}
                                  <br />
                                  {`${ERPUtils.isNullorWhiteSpace(el?.specialization) === false ? el?.specialization : ""}`}
                                  <br />
                                  {!ERPUtils.isUndefinedOrNull(el?.documentList) ? (
                                    <Link aria-describedby={anchorEl} component="button" onClick={(e) => handleClick(e, el?.documentList)} underline="none">
                                      View Documents
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </label>
                              </div>
                            );
                          })
                        : null}

                      {ERPUtils.isUndefinedOrNull(previewData.educationalDetailDTO?.eligibilityTestList) === false
                        ? previewData.educationalDetailDTO?.eligibilityTestList.map((el, index) => {
                          return (
                            <div className="row" key={index}>
                              <label className="col-md-1 PreviewFormLabel iconIconLabelRight">
                                <span className="fa fa-star SpanIcon" />
                              </label>
                              <label className="col-md-11 PreviewFormLabel iconDataLabel">
                                {`${ERPUtils.isUndefinedOrNull(el?.eligibilityTestId) === false ? el?.eligibilityTestId : ""}`} <br />
                                {`Test year  - ${ERPUtils.isUndefinedOrNull(el?.testYear) === false ? el?.testYear : ""}`}
                                <br />
                                {!ERPUtils.isUndefinedOrNull(el?.eligibilityTestDocumentsList) ? (
                                  <Link
                                    aria-describedby={anchorEl}
                                    component="button"
                                    onClick={(e) => handleClick(e, el?.eligibilityTestDocumentsList)}
                                    underline="none"
                                  >
                                    View Documents
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </label>
                            </div>
                          );
                        })
                        : null}
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : null}
              {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) === false &&
                (!ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeApplicationNo) ||
                  !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeDepartment) ||
                  !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeSubject) ||
                  !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeYear) ||
                  !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.vacancyInformationId) ||
                  !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.otherInformation)
                ) ? (
                <div className="previewBox previewBox-personal">
                  <div className="previewBox-header with-border">
                    <h3 className="previewBox-title">
                      {" "}
                      {!ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeApplicationNo) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeDepartment) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeSubject) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.vacancyInformationId) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeYear) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.otherInformation)
                        ? "Additional Details"
                        : ""}
                    </h3>
                  </div>
                  <div className="m-1">
                    <div className="PreviewBoxBody">
                      {!ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeApplicationNo) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeDepartment) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeSubject) ||
                        !ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeYear) ? (
                        <h6 className="previewBox-title">
                          <b>Previous Interview Details</b>
                        </h6>
                      ) : (
                        ""
                      )}
                      <div style={{ margin: "7px" }}>
                        {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO.interviewedBeforeApplicationNo) === false ? (
                          <div className="row">
                            <label className="col-md-4 PreviewFormLabel">Application No</label>
                            <label className="col-md-7 PreviewFormLabel">
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeApplicationNo) === false
                                ? previewData?.researchDetailDTO?.interviewedBeforeApplicationNo
                                : ""}
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                        {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeYear) === false ? (
                          <div className="row">
                            <label className="col-md-4 PreviewFormLabel">Year</label>
                            <label className="col-md-7 PreviewFormLabel">
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeYear) === false
                                ? previewData?.researchDetailDTO?.interviewedBeforeYear
                                : ""}
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                        {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeDepartment) === false ? (
                          <div className="row">
                            <label className="col-md-4 PreviewFormLabel">Department</label>
                            <label className="col-md-7 PreviewFormLabel">
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeDepartment) === false
                                ? previewData?.researchDetailDTO?.interviewedBeforeDepartment
                                : ""}
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                        {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeSubject) === false ? (
                          <div className="row">
                            <label className="col-md-4 PreviewFormLabel">Subject</label>
                            <label className="col-md-7 PreviewFormLabel">
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.interviewedBeforeSubject) === false
                                ? previewData?.researchDetailDTO?.interviewedBeforeSubject
                                : ""}
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                        {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.vacancyInformationId) === false ? (
                          <div className="row">
                            <label className="col-md-4 PreviewFormLabel">How did you know about vacancy/Position?</label>
                            <label className="col-md-7 PreviewFormLabel">
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.vacancyInformationId) === false
                                ? previewData?.researchDetailDTO?.vacancyInformationId
                                : ""}
                            </label>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="PreviewBoxBody">
                    {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.otherInformation) === false ? (
                      <div className="row text-break" style={{ margin: " 2px" }}>
                        <h6 className="previewBox-title">

                          <b>Other Information</b>
                        </h6>
                        {/* <label className="col-md-1 PreviewFormLabel iconIconLabelLeft"><span className="fa fa-arrow-right SpanIcon" /></label> */}
                        <label className="col-md-11 PreviewFormLabel iconDataLabel" style={{ textAlign: "justify" }}>
                          {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.otherInformation) === false
                            ? previewData?.researchDetailDTO?.otherInformation
                            : ""}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : null}

              {/* {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) ===
										false ? ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO.researchEntries) ===
											false ? ERPUtils.isUndefinedOrNull(
												previewData.researchDetailDTO.researchEntries.researchEntriesHeadings
											) === false ? (
										<div className="previewBox previewBox-personal">
											<div className="previewBox-header with-border">
												<h3 className="previewBox-title">Research summary</h3>
											</div>
											<div className="PreviewBoxBody">
												{previewData.researchDetailDTO.researchEntries.researchEntriesHeadings.map(
													(el, index) => {
														return (
															<div className="row" key={index}>
																<label className="col-md-12 PreviewFormLabel">
																	{el.groupHeading}
																</label>
																{ERPUtils.isUndefinedOrNull(el.parameters) === false ? (
																	el.parameters.map((item, idx) => {
																		return (
																			<label
																				className="col-md-12 PreviewFormLabel"
																				key={idx}
																			>
																				<label className="col-md-4">
																					{item.researchParameter}
																				</label>
																				<label className="col-md-2">
																					{item.parameterValue}
																				</label>
																			</label>
																		);
																	})
																) : null}
															</div>
														);
													}
												)}
											</div>
										</div>
									) : null : null : null} */}
            </div>
            <div className="col-md-12">
              {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) === false ||
                ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.researchEntries) === false ? (
                ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.inflibnetVidwanNo) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.scopusId) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.hIndex) === false ||
                  ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.orcidId) === false ||
                  ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO.researchEntries) === false ? (
                  <section className=" ">
                    <div className=" PreviewFormLabel previewBox PreviewHeader previewBox-profileSummary  ">
                      {!ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) === true ||
                        ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.researchEntries) === false ? (
                        ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.inflibnetVidwanNo) === false ||
                          ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.scopusId) === false ||
                          ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.hIndex) === false ||
                          ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.orcidId) === false ? (
                          <div className=" ">
                            <div className="previewBox-header with-border">
                              <h3 className="previewBox-title">Research Details</h3>
                            </div>
                            <div className="PreviewBoxBody ">
                              {!ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.inflibnetVidwanNo) === true ? (
                                <div className="col-md-4 pt-2">
                                  <label className=" PreviewFormLabel ">
                                    <b>Vidwan ID :</b>
                                  </label>
                                  <label className=" PreviewFormLabel ReserchOne">
                                    {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.inflibnetVidwanNo) === false
                                      ? previewData?.researchDetailDTO?.inflibnetVidwanNo
                                      : ""}
                                  </label>
                                </div>
                              ) : (
                                ""
                              )}
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.scopusId) === false ? (
                                <div className="col-md-4 pt-2">
                                  <label className=" PreviewFormLabel ">
                                    <b>Scopus ID :</b>
                                  </label>
                                  <label className=" PreviewFormLabel ReserchOne">
                                    {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.scopusId) === false
                                      ? previewData?.researchDetailDTO?.scopusId
                                      : ""}
                                  </label>
                                </div>
                              ) : (
                                ""
                              )}
                              {!ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.hIndex) === true ? (
                                <div className="col-md-4 pt-2">
                                  <label className=" PreviewFormLabel">
                                    <b>H Index :</b>
                                  </label>
                                  <label className=" PreviewFormLabel ReserchOne">
                                    {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.hIndex) === false ? previewData?.researchDetailDTO?.hIndex : ""}
                                  </label>
                                </div>
                              ) : (
                                ""
                              )}
                              {ERPUtils.isUndefinedOrNull(previewData?.researchDetailDTO?.orcidId) === false ? (
                                <div className="col-md-6 pt-2">
                                  <label className=" PreviewFormLabel">
                                    <b>ORCID :</b>
                                  </label>
                                  <label className=" PreviewFormLabel ReserchOne">
                                    {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.orcidId) === false ? previewData.researchDetailDTO?.orcidId : ""}
                                  </label>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : null
                      ) : null}

                      {ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO) === false ? (
                        ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.researchEntries) === false ? (
                          ERPUtils.isUndefinedOrNull(previewData.researchDetailDTO?.researchEntries?.researchEntriesHeadings) === false ? (
                            <div className=" ">
                              <div className="previewBox-header with-border">
                                <h3 className="previewBox-title">Research summary</h3>
                              </div>
                              <div className="PreviewBoxBody " style={{ paddingLeft: "13px" }}>
                                {previewData.researchDetailDTO?.researchEntries?.researchEntriesHeadings.map((el, index) => (
                                  <div className="row" key={index}>
                                    <label className="col-md-12 PreviewFormLabel">
                                      <b>{el.groupHeading}</b>
                                    </label>
                                    {ERPUtils.isUndefinedOrNull(el?.parameters) === false
                                      ? el.parameters.map((item, idx) => (
                                        <label className="col-md-12 PreviewFormLabel" key={idx}>
                                          <label className="col-md-5">{item.researchParameter}</label>
                                          <label className="col-md-5 ">{item.parameterValue}</label>
                                        </label>
                                      ))
                                      : null}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : null
                        ) : null
                      ) : null}
                    </div>
                  </section>
                ) : null
              ) : null}
              {!ERPUtils.isUndefinedOrNull(previewData.additionalInformations) ? (
                <div>
                  <div className="pagebreak"> </div>
                  <div className="previewHeader row">
                    {/* <div className="previewBox-header with-border">
										<h3 className="previewBox-title">Additional Information to Application</h3>
									</div> */}
                  </div>
                  <section className="PreviewContent">
                    <div className="previewBox previewBox-personal">
                      <div className="PreviewBoxBody">
                        <div className="previewBox-header with-border">
                          <h3 className="previewBox-title">Additional Information to Application</h3>
                        </div>
                        {!ERPUtils.isUndefinedOrNull(previewData.additionalInformations?.researchEntriesHeadings)
                          ? previewData.additionalInformations.researchEntriesHeadings.map((el, index) => {
                            return (
                              <div className="row" key={index}>
                                <label className="col-md-12 PreviewFormLabel" style={{ fontSize: "1.1rem" }}>
                                  {`${el.groupHeading}`}
                                  {!ERPUtils.isUndefinedOrNull(el.parameters)
                                    ? el.parameters.map((el1, index1) => {
                                      return (
                                        <>
                                          <div className="row mt-2" key={`${index}_${index1}`}>
                                            <div className="col-md-12">
                                              <label className="PreviewFormLabel ml-3">{`${el1.researchParameter}`}</label>
                                            </div>
                                          </div>
                                          <div className="row" key={`${index}_${index1}`}>
                                            <div className="col-md-12">
                                              <label className="PreviewFormLabel ml-4">
                                                <font style={{ fontStyle: "italic" }}>{`${el1.parameterValue}`}</font>
                                              </label>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })
                                    : null}
                                  {previewData.additionalInformations.researchEntriesHeadings.length - 1 !== index ? <br /> : null}
                                </label>
                              </div>
                            );
                          })
                          : null}
                      </div>
                    </div>
                  </section>
                </div>
              ) : null}
            </div>
          </div>
        </section>
        {/* </div> */}
        <div></div>
      </DialogContent>
    </Dialog >
  ) : null;
};

export default ApplicationPreview;
